<template>
	<InfoTiles :tiles="tiles" />
</template>

<script setup>
import { computed } from 'vue';
import { useTranslator } from '@/composables/useTranslator';
import InfoTiles from '@/components/common/InfoTiles.vue';
import { formatNumber, formatValue, formatWeight, formatPricePerKg } from '@/utils/core/format';

const props = defineProps({
	ratios: { type: Object, required: true },
	showValue: { type: Boolean, default: true },
	showWeight: { type: Boolean, default: true },
});

const t = useTranslator();

const tiles = computed(() => {
	const list = [
		{ key: 'orderCount', icon: 'shopping_cart', label: t('OrderCount'), display: formatNumber(props.ratios.orderCount) },
		{ key: 'productsPerOrder', icon: 'inventory_2', label: t('ProductsPerOrder'), display: formatNumber(props.ratios.productsPerOrder, { decimals: 1 }) },
	];

	if (props.showValue) list.push({ key: 'valuePerOrder', icon: 'paid', label: t('ValuePerOrder'), display: formatValue(props.ratios.valuePerOrder) });
	if (props.showWeight) list.push({ key: 'weightPerOrder', icon: 'scale', label: t('WeightPerOrder'), display: formatWeight(props.ratios.weightPerOrder) });
	if (props.showValue && props.showWeight) list.push({ key: 'pricePerKg', icon: 'sell', label: t('PricePerKg'), display: formatPricePerKg(props.ratios.pricePerKg) });

	return list;
});
</script>
